module.exports = __webpack_public_path__ + "img/temp_wc1.56c6070a.jpg";